export const TOOL = {
    FORUM: {name: 'FORUM', code: 'forum'},
    BULLETIN: {name: 'BULLETIN', code: 'bulletin'},
    MARK: {name: 'MARK', code: 'mark'},
    HOMEWORK: {name: 'HOMEWORK', code: 'homework'},
};